export default __webpack_public_path__ + "static/media/port-green.e1d6de2b.svg";